import { REACT_APP_API } from '../../config';
import axios from 'axios';

const USERS_ENDPOINT = `${REACT_APP_API}/users/`;

export async function verifyRestorePassword(dni, email) {
  const response = await axios.put(`${USERS_ENDPOINT}${email}/${dni}/restorePassword`);

  return response?.data;
}